import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {isObject} from "../helpers/utils";
import {setDonationAmount, makeDonation} from "../reducers/files";

class Summary extends Component {
  render () {
    const {summary, donate, donationAmount, setDonationAmount, processing, email} = this.props;
    const {riskFactor5, riskFactor10} = summary;
    const wrongAmount = isNaN(donationAmount);
    
    return [
      <div className="default-block container" key={0}>
        <h2 style={{textAlign: 'center', fontWeight: 600, marginBottom: 60}}>Sprawdź <span style={{color: '#F54D4D'}}>ryzyko plagiatu</span></h2>
        <figure className="wp-block-table alignfull is-style-stripes">
          <table>
            <tbody>
            <tr>
              <td className="has-text-align-center" data-align="center" style={{color: 'inherit'}}><strong>Wynik dla</strong></td>
              <td className="has-text-align-center" data-align="center" style={{color: 'inherit'}}><strong>Wynik niski</strong></td>
              <td className="has-text-align-center" data-align="center" style={{color: 'inherit'}}><strong>Wynik wysoki</strong></td>
            </tr>
            <tr>
              <td className="has-text-align-center" data-align="center">Fraza 10 slów</td>
              <td className="has-text-align-center" data-align="center" style={{borderColor: '#F54D4D', color: '#F54D4D', borderWidth: 2, fontWeight: 600}}>{riskFactor10.low}% PRP</td>
              <td className="has-text-align-center" data-align="center">{riskFactor10.high}% PRP</td>
            </tr>
            <tr>
              <td className="has-text-align-center" data-align="center">Fraza 5 slów</td>
              <td className="has-text-align-center" data-align="center">{riskFactor5.low}% PRP</td>
              <td className="has-text-align-center" data-align="center">{riskFactor5.high}% PRP</td>
            </tr>
            </tbody>
          </table>
        </figure>
      </div>,
      <div className="default-block container" key={1}>
        <p style={{color: '#82858C', textAlign: 'center', fontWeight: 900, marginTop: 40}}>Ryzyko plagiatu: {riskFactor10.low < 25 ? <span style={{color: '#11dc11'}}>niskie</span> : (riskFactor10.low > 49 ? <span style={{color: '#F54D4D'}}>wysokie</span> : <span style={{color: '##ff9a00'}}>średnie</span>)}</p>
      </div>,
      ...donate ? [
        <div className="default-block container" key={2} style={{textAlign: 'center'}}>
          <h4><span style={{color: 'rgb(245, 77, 77)'}}>Wesprzyj rozwój programu! Dla przyszłych roczników</span><br/>
             Wpłać dowolną kwotę, a my przeznaczymy ją na dalszy rozwój systemu</h4>
          <input className={`send-to-email number-field ${wrongAmount ? 'wrong-email' : ''}`}
                 type="number"
                 style={{paddingTop: 13, paddingBottom: 13}}
                 onChange={e => {
                   setDonationAmount(e.target.value);
                 }}
                 value={wrongAmount ? '' : donationAmount}/>
          <button className="wp-block-button__link has-white-color has-text-color has-background compare-button"
                  style={{borderRadius: 5, backgroundColor: '#f54d4d', marginLeft: 10}}
                  disabled={wrongAmount || processing}
                  onClick={() => {
                    makeDonation({
                      email,
                      amount: donationAmount
                    })
                  }}>Wspieram</button>
        </div>
      ] : []
    ]
  }
}

Summary.propTypes = {
  summary: PropTypes.object,
  donate: PropTypes.bool,
  donationAmount: PropTypes.number,
  setDonationAmount: PropTypes.func,
  processing: PropTypes.bool,
  email: PropTypes.string
};

Summary.defaultProps = {
  summary: {},
  donate: false,
  setDonationAmount: () => {},
  processing: false
};

export default connect(
  ({report, donate, donationAmount, processing, email}) => ({
    summary: isObject(report) && isObject(report.summary) ? report.summary : {},
    email,
    donate,
    donationAmount,
    processing
  }),
  {setDonationAmount}
)(Summary);
